import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCan } from '@shared/rbac/useCan';
import { ROUTES } from '@shared/constants/routes';
import type { Permission } from '@shared/rbac/permissions.const';

interface RoleGuardProps {
  permission: Permission;
  fallback?: ReactNode;
  children: ReactNode;
}

export function RoleGuard({ permission, fallback, children }: RoleGuardProps) {
  const can = useCan(permission);
  if (can) return <>{children}</>;
  return <>{fallback ?? <Navigate to={ROUTES.FORBIDDEN} replace />}</>;
}
